import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { BlocoNotaDBService } from '../database/bloco-nota-db.service';

@Injectable({providedIn: 'root'})
export class BlocoNotaService extends BaseService {
    override classname = 'BlocoNotaService';
    override route = 'bloco-nota';
    override database = new BlocoNotaDBService();

    override novo() {
        return {tipo: 'LEMBRETE_GERAL', status: 'ABERTA', itens: []};
    }
}
